import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import { NotificationMessage } from '../dialogue.models';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-notification-dial',
  templateUrl: './notification-dial.component.html',
  styleUrls: ['./notification-dial.component.scss'],
  imports: [MatDialogTitle, MatDialogContent, MatDivider, MatButton],
})
export class NotificationDialComponent {
  /** Inject services. */
  private readonly dialogRef = inject<MatDialogRef<NotificationDialComponent>>(MatDialogRef);
  readonly dialogData = inject<NotificationMessage>(MAT_DIALOG_DATA);

  onClick(): void {
    this.dialogRef.close();
  }
}
